import { gql } from '@apollo/client';
const SET_DEFAULT_SIZE_STANDARD = gql `
  mutation SetDefaultSizeStandard($modelSpecificationSizeStandardId: ID!) {
    setDefaultModelSpecificationSizeStandard(
      modelSpecificationSizeStandardId: $modelSpecificationSizeStandardId
    ) {
      modelSpecificationSizeStandard {
        id
        name
        isActive
        isDefault
        canNameBeUpdated
        canBeRemoved
      }
    }
  }
`;
export default SET_DEFAULT_SIZE_STANDARD;
